import ACLStore from "lib/aclStore";
import { getThumbUrl } from "Utils/AttachmentHelpers";
import _ from "lodash";

import { getProgramListForModule } from "Platform/routes/HomePage/modules/HomePageUtils";
import { IMAGE_THUMB_SIZE, MAP_FEED_TYPES } from "./Constants";
import {
  PLACEHOLDER_RECT_IMAGE,
  PLACEHOLDER_RECT_IMAGE_COUNT,
} from "Constants";
import { getRethumbUrl } from "Utils";

export const getIsCurriculumMapsEnabled = () => {
  return ACLStore.can("FeatureFlag:EnableCurriculumMaps");
};

export const getDefaultRoute = () => {
  return MAP_FEED_TYPES.COURSE_MAP;
};

export const TAB_OPTIONS = [
  {
    label: "curriculumMaps:course_map",
    value: MAP_FEED_TYPES.COURSE_MAP,
  },
  {
    label: "curriculumMaps:grade_map",
    value: MAP_FEED_TYPES.GRADE_MAP,
  },
  {
    label: "curriculumMaps:department_map",
    value: MAP_FEED_TYPES.DEPARTMENT_MAP,
  },
];

export const getOptimizedImageUrl = value => {
  if (_.isEmpty(value)) return value;

  const attachment = {
    type: "IMAGE",
    url: value,
  };

  const { thumbUrl } = getThumbUrl({
    attachment,
    width: IMAGE_THUMB_SIZE,
    height: IMAGE_THUMB_SIZE,
  });

  return thumbUrl || value;
};

const getCardImageRethumb = imageUrl => {
  const rethumbUrl = imageUrl
    ? getRethumbUrl({ width: 700, height: 700, imageUrl, fitIn: true })
    : "";
  return `url(${rethumbUrl})`;
};

export const getDefaultCardImage = ({ id, imageUrl }) => {
  const hash = _.sumBy(String(id), char => char.charCodeAt(0));
  return !_.isEmpty(imageUrl)
    ? getCardImageRethumb(imageUrl)
    : `url(${PLACEHOLDER_RECT_IMAGE[hash % PLACEHOLDER_RECT_IMAGE_COUNT]})`;
};

export const getEnabledCurriculumPrograms = (userCurriculumPrograms = []) => {
  const enabledProgramIds = _.get(
    getProgramListForModule("CURRICULUM_MAPS"),
    "enabledCurriculumProgramIds",
    []
  );

  return _.isEmpty(enabledProgramIds)
    ? userCurriculumPrograms
    : _.filter(userCurriculumPrograms, program =>
        _.includes(enabledProgramIds, program.id)
      );
};

export const getSelectedFiltersCount = filters => {
  return _.reduce(
    filters,
    (count, values) => {
      if (!_.isEmpty(values)) {
        return count + 1;
      }
      return count;
    },
    0
  );
};

export const createSidebarOptions = ({
  gradeList,
  t,
  activeMapType,
  departmentList,
}) => {
  let options = [];
  let header = {};

  const makeOptions = list =>
    _.map(list, item => ({
      key: item.id,
      title: item.name,
      tier: 1,
      parent: "root",
    }));

  switch (activeMapType) {
    case MAP_FEED_TYPES.GRADE_MAP: {
      options = makeOptions(gradeList);
      header = { heading: t("common:grade_plural") };
      break;
    }
    case MAP_FEED_TYPES.DEPARTMENT_MAP: {
      options = makeOptions(departmentList);
      header = { heading: t("common:department_plural") };
      break;
    }
    default:
      break;
  }

  const rootOption = {
    key: "root",
    children: _.map(options, "key"),
  };

  const optionList = [rootOption, ...options];
  return { optionList, header };
};
